<template>
  <AsyncPage
    :loader="useTransactionsLoader"
    :page-component="Transactions"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useTransactionsLoader } from "./Transactions.loader.ts";
import { transactions as strings } from "./Transactions.strings.ts";
import { AsyncPage } from "@saflib/vue/components";
import { useAsyncPageDocumentTitle } from "@saflib/vue";

useAsyncPageDocumentTitle(strings.documentTitle);

const Transactions = defineAsyncComponent(
  () => import("./Transactions.vue"),
);
</script>
